import io from 'socket.io-client';

export const baseURL = "https://sac.sistemaspower.com.br";

export default io(baseURL);